import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">The confident sell</div>
                                            <p>If you’ve looked at all the angles and you genuinely believe in
                                                the plan you’re putting forward, people will notice this
                                                confidence and it will in turn inspire confidence in them.</p>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">PRESENTING YOUR VISION</span>
                                            </div>
                                            <div className="border_subtitle">Top tips to presenting your
                                                vision:
                                            </div>
                                            <ol className="brownbullet-list listcontentSpacing tableliclass1">
                                                <li><p>Tailor your approach by emphasising those aspects of your
                                                    idea to which the majority of your audience will react
                                                    positively.</p></li>
                                                <li><p>Outline the key facts simply. Leave the detail to later.
                                                    What is your idea? What are its most important elements? How
                                                    will it work?</p></li>
                                                <li><p>Highlight both pros and cons and make it clear you’ve
                                                    given thought to reducing potential risks.</p></li>
                                                <li><p>Generate enthusiasm for your idea by explaining why it’s
                                                    necessary and the benefits it will deliver, with energy and
                                                    conviction.</p></li>
                                                <li><p>Start and finish on a high because research shows that
                                                    audiences are likely to remember the first and last part of
                                                    any communication more readily. </p></li>
                                                <li><p> Consider the broader implications of your idea in the
                                                    context of what the business is trying to achieve and
                                                    indicate how it would contribute to future success.</p></li>
                                            </ol>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">GAIN BUY-IN PREFERENCE TEST</span>
                                            </div>
                                            <p>We’ve designed this exercise to help you establish the best
                                                methods to use, according to your personality, to achieve
                                                buy-in. It will help you persuade others to commit to your idea
                                                when presenting your views and establish partnerships and
                                                winning agreements to the ‘deal’ (stages 3-5 of our model).
                                                Complete the questionnaire to identify the methods you’d choose
                                                and then use the ‘preferences table’ to understand more about
                                                them.</p>
                                            <p>There are 16 items, each describing a specific approach to
                                                gaining ‘buy-in’. Using the scale rate how often you demonstrate
                                                each one described. Circle the score in the corresponding ‘Self
                                                Assessment’ column overpage.</p>
                                            <div className="lightgreencontentbg keyquestionpad lightgreenBG4">
                                                <p>
                                                    1 = Almost never demonstrated
                                                </p>
                                                <p>2</p>
                                                <p>3 = Occasionally demonstrated</p>
                                                <p>4</p>
                                                <p>5 = Sometimes demonstrated</p>
                                                <p>6</p>
                                                <p>7 = Frequently demonstrated</p>
                                                <p>8</p>
                                                <div className="uiheading">
                                                    <p>9 = Almost always demonstrated</p></div>
                                            </div>
                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page4')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}